import {memo, useCallback} from 'react'
import {LogIn} from 'lucide-react'
import {Alert, AlertDescription, AlertTitle, Button, Input} from '@/shared/ui'

interface LobbyFormProps {
  username: string
  onUsernameChange: (value: string) => void
  onJoin: () => void
  deviceWarning: string | null
  isReady: boolean
}

export const LobbyForm = memo(function LobbyForm({
  username,
  onUsernameChange,
  onJoin,
  deviceWarning,
  isReady,
}: LobbyFormProps) {
  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onUsernameChange(e.target.value)
    },
    [onUsernameChange],
  )

  return (
    <div className="flex flex-col gap-4">
      {deviceWarning && (
        <Alert variant="warning">
          <AlertTitle>Предупреждение о доступе к устройствам</AlertTitle>
          <AlertDescription>{deviceWarning}</AlertDescription>
        </Alert>
      )}

      <div className="flex flex-col gap-2">
        <label htmlFor="username" className="text-sm font-medium text-foreground/80">
          Ваше имя
        </label>
        <Input
          id="username"
          type="text"
          value={username}
          onChange={handleInputChange}
          placeholder="Гость"
          maxLength={30}
        />
      </div>

      <Button onClick={onJoin} size="lg" className="w-full" disabled={!isReady}>
        <LogIn />
        Войти в комнату
      </Button>
    </div>
  )
})
